import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { StudentsAchievementsRoutingModule } from './students-achievements-routing.module';
import { StudentsAchievementsListComponent } from './students-achievements-list/students-achievements-list.component';
import { StudentsAchievementsCreateComponent } from './students-achievements-create/students-achievements-create.component';

@NgModule({
  declarations: [StudentsAchievementsListComponent, StudentsAchievementsCreateComponent],
  imports: [
    CommonModule,
    StudentsAchievementsRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule
  ]
})
export class StudentsAchievementsModule { }
